import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';

type Props = {
	title: string;
	description: string;
	image: ReactNode;
	testId?: string;
};

export const ErrorView = ({ image, title, description, testId }: Props) => (
	<Container data-testid={testId}>
		{image}
		<h4>{title}</h4>
		<Description>{description}</Description>
	</Container>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	padding: `${token('space.300', '24px')}`,
	paddingTop: ` ${token('space.500', '40px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 32}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Description = styled.p({
	margin: `${token('space.200', '16px')} 0`,
	textAlign: 'center',
});
